const read = (params, credentials) => {
  return fetch("/api/auth/users/" + params.userId, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + credentials.t
    }
  })
    .then(response => {
      return response.json();
    })
    .catch(err => console.log(err));
};

export default read;



// WEBPACK FOOTER //
// ./src/components/auth/authUser.js